import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "FilterWrapper col-12 border rounded bg-white" };
const _hoisted_2 = { class: "filterBoxHeadline row" };
const _hoisted_3 = { class: "col-12 pt-3 pb-2" };
const _hoisted_4 = { class: "font6-responsive strong" };
const _hoisted_5 = { class: "count_products" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b;
    const _component_filter_sorting = _resolveComponent("filter-sorting");
    const _component_filter_reset_all = _resolveComponent("filter-reset-all");
    const _component_filter_deals = _resolveComponent("filter-deals");
    const _component_filter_newly_arrived = _resolveComponent("filter-newly-arrived");
    const _component_open_popup_button = _resolveComponent("open-popup-button");
    const _component_filter_universal = _resolveComponent("filter-universal");
    const _component_filter_price_range = _resolveComponent("filter-price-range");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h3", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString((_b = (_a = _ctx.currentPageInfo) === null || _a === void 0 ? void 0 : _a.total) !== null && _b !== void 0 ? _b : 0), 1),
                    _cache[0] || (_cache[0] = _createTextVNode(" Produkte ", -1))
                ])
            ])
        ]),
        _createVNode(_component_filter_sorting),
        _createVNode(_component_filter_reset_all),
        _createVNode(_component_filter_deals),
        _createVNode(_component_filter_newly_arrived),
        _createVNode(_component_filter_universal, {
            filterHeadline: "Zustand",
            filterType: _ctx.BlueFilterType.CONDITIONS
        }, {
            extraFilterContent: _withCtx(() => [
                _createVNode(_component_open_popup_button, { "popup-name": "conditionsPopup" }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("div", {
                                class: "link-gray font8-responsive mb-3 [ track_blue_filters_condition_infos ]",
                                title: "Zustandsbeschreibung"
                            }, " Was ist damit gemeint? ", -1)
                        ]))]),
                    _: 1
                })
            ]),
            _: 1
        }, 8, ["filterType"]),
        _createVNode(_component_filter_universal, {
            filterHeadline: "Hersteller",
            filterType: _ctx.BlueFilterType.BRANDS
        }, null, 8, ["filterType"]),
        _createVNode(_component_filter_price_range)
    ]));
}
